






















import Proxyable from '@/mixins/proxyable';
import { ITimeOffRequest, TimeOffStateEnum } from '@/models';
import TimeOffRequestDetailMenuCard from './TimeOffRequestDetailMenuCard.vue';

export default Proxyable.extend({
  name: 'TimeOffCalendarEvent',

  props: {
    event: Object
  },

  components: { TimeOffRequestDetailMenuCard },

  data: () => ({
    TimeOffStateEnum
  }),

  watch: {
    internalValue(value) {
      if (value) {
        this.$emit('open:menu', this.event);
      }
    }
  },

  methods: {
    open(event: ITimeOffRequest) {
      this.$emit('open', event);
    },

    close() {
      this.internalValue = false;
      this.$emit('close:menu', this.event);
    },

    rebuild() {
      this.$emit('rebuild');
    }
  }
});
